import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionAccountholderVM } from 'practice/view-models/practice-detail';
import PmiTextField from 'shell/components/shared/text-field';

interface FormProps {
  disabled?: boolean;
  onChange: (
    key: keyof AccordionAccountholderVM,
    value: AccordionAccountholderVM[keyof AccordionAccountholderVM]
  ) => void;
  values?: AccordionAccountholderVM;
}

const FormComponent = ({ disabled, onChange, values }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscalCode"
          name="fiscalCode"
          fullWidth
          disabled={disabled}
          variant="outlined"
          value={values?.fiscalCode?.toUpperCase() || ''}
          onChange={(event) => onChange('fiscalCode', event.target.value)}
          inputProps={{ maxLength: '16' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Checkbox
              id="isAire"
              checked={values?.isAire || false}
              onChange={() => onChange('isAire', !values?.isAire)}
              inputProps={{ 'aria-label': 'Aire' }}
              disabled={disabled}
            />
          }
          label="AIRE"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          value={values?.surname || ''}
          onChange={(event) => onChange('surname', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurname-replica"
              checked={values?.withoutSurname || false}
              onChange={() => onChange('withoutSurname', !values?.withoutSurname)}
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
              disabled={disabled}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          value={values?.name || ''}
          onChange={(event) => onChange('name', event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutName-replica"
              checked={values?.withoutName || false}
              onChange={() => onChange('withoutName', !values?.withoutName)}
              inputProps={{ 'aria-label': 'Persona senza nome' }}
              disabled={disabled}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion applicant - accountholder';

const Form = memo(FormComponent);

export default Form;
